export const invoiceTemplatesDirectoryPath = ln => global.isProd
    ? `buildServer/server/models/cnda/mails/templates/${ln}/invoice`
    : `src/server/models/cnda/mails/templates/${ln}/invoice`
